import React from 'react';
import styles from './Hero.module.css';

const Hero: React.FC = () => (
  <div className={styles.heroTile}>
    <div className={styles.mlabel}>
      <span><span className={styles.glyph}>▦</span> Oak Cliff · Dallas, TX</span>
      <span className={styles.mno}>00</span>
    </div>
    <h1 className={styles.wordmark}>
      OAKCLIFF<span className={styles.dot}>.</span>TECH
    </h1>
    <p className={styles.tagline}>
      Where Oak&nbsp;Cliff's designers, developers, engineers, and founders find each other.
    </p>
  </div>
);

export default Hero;
